import Hubspot from '../Hubspot';
import QueryString from 'query-string';

export default class HubspotScraper {
  constructor() {
    this.hubspotJavaScriptUrl = document.getElementById('HubspotApi')
      ? document.getElementById('HubspotApi').value
      : 'https://js.hsforms.net/forms/v2.js';

    if (this.hubspotJavaScriptUrl) {
      this.initHubspotScraper();
    }
  }

  initHubspotScraper() {
    this.initScrapeDom = this.initScrapeDom.bind(this);
    this.initScrapeDom();
  }

  initScrapeDom() {
    const documentLinks = Array.from(document.links);
    const hubspotLinkArray = [];

    const hubspotInPageForms = [...document.querySelectorAll('#hubspotInPageForm')];

    documentLinks.forEach((link) => {
      const linkIncludesPortalId = link.hash.toLowerCase().includes('portalid');
      if (linkIncludesPortalId) {
        hubspotLinkArray.push(link);
      }
    });

    if (hubspotLinkArray.length > 0) {
      let portalId;
      let formId;

      hubspotLinkArray.forEach((hubspotLinkElement, index) => {
        if (index === 0) {
          // set this.element to the first hubspot link element.
          this.element = hubspotLinkElement;
        }

        const queryStringParams = QueryString.parse(hubspotLinkElement.hash);
        if (queryStringParams.formId && queryStringParams.portalId) {
          formId = queryStringParams.formId;
          portalId = queryStringParams.portalId;
        } else if (queryStringParams.formid && queryStringParams.portalid) {
          formId = queryStringParams.formid;
          portalId = queryStringParams.portalid;
        }

        if (formId && portalId) {
          const hubspotInstance = new Hubspot(index, true);
          hubspotLinkElement.addEventListener('click', hubspotInstance.onHubspotButtonClick(formId, portalId));
        }
      });
    }

    if (hubspotInPageForms.length > 0) {

      hubspotInPageForms.forEach((hubspotInPageForm, index) => {
        const formId = hubspotInPageForm.dataset.formId;
        const portalId = hubspotInPageForm.dataset.portalId;
        const hubSpotForm = new Hubspot(index, false);
        hubSpotForm.openHubspotForm(formId, portalId, hubspotInPageForm);
      });
    }
  }
}